const lazyLoadOffset = -50;

const lazyLoad = () => {
    let imgObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const $entry = $(entry.target);
                const dataSrc = $entry.attr('data-src');
                if(dataSrc) {
                    $entry.attr('src', dataSrc);
                }

                observer.unobserve(entry.target);
            }
        });
    }, { rootMargin: `0px 0px ${lazyLoadOffset}px 0px` });

    $('img').toArray()
        .forEach(img => { imgObserver.observe(img) });

    let divObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const $entry = $(entry.target);
                const dataStyle = $entry.attr('data-style');
                if (dataStyle) {
                    $entry.attr('style', dataStyle);
                }

                observer.unobserve(entry.target);
            }
        });
    }, { rootMargin: `0px 0px ${lazyLoadOffset}px 0px` });

    $('div[data-style], section[data-style]').toArray()
        .forEach(div => { divObserver.observe(div) });
};

export default lazyLoad;
